/*  ==========================================================================
		PHP Variables
		========================================================================== */

// If you need to access variables such as template url, or AJAX url within this file you can use the variable php_variables.template_url or php_variables.ajax_url
// which has been passed in via enqueue-scripts.php

/*  ==========================================================================
		Grid variables - needed for gridcarousel__init
		========================================================================== */

// NOTE: If your updating this make sure to also update the SASS Variables in _variables.scss
const gridSizes = {
  sm: "550",
  md: "700",
  lg: "1000",
  xl: "1200",
  ws: "1400",
  xw: "1600",
  xxw: "1800",
  xxxw: "2000"
};

/*  ==========================================================================
      DOM element variables 
      ========================================================================== */

const body = document.querySelector("body");

/*  ==========================================================================
		Device Detection - Check if is mobile or ipad
		========================================================================== */

let isMobile = false; // initiate as false
const isTouchDevice = !!("ontouchstart" in window);

if (/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(window.navigator.userAgent)) {
  isMobile = true;
}

/*  ==========================================================================
		GENERAL - Cookie functions 
		========================================================================== */

function setCookie(cname, cvalue, exhours, cpath = "/") {
  const d = new Date();
  d.setTime(d.getTime() + exhours * 60 * 60 * 1000);
  let expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=" + cpath;
}

function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

/*  ==========================================================================
		GENERAL - add linklines to links
		========================================================================== */

const linksInit = function () {
  const links = document.querySelectorAll("a:not(.noline):not(.line--added)");
  links.forEach(function (el) {
    if (el.closest(".noline")) {
      return;
    }

    const icon = el.querySelector(".fa, .fas, .far, .fal, .fab");

    if (el.querySelector("img") < 1) {
      const linkHTML = "<span class='linkline'>" + el.textContent + "</span>";
      el.innerHTML = linkHTML;
      el.classList.add("line--added");
      if (icon) {
        const iconHTML = icon;
        if (icon.classList.contains("fa--left")) {
          el.querySelector(".linkline").before(icon);
        } else {
          el.querySelector(".linkline").after(icon);
        }
      }
    }
  });
  //return true;
}; // linksInit();
linksInit();

/*  ==========================================================================
    GENERAL - sharinglinks
    ========================================================================== */

const sharingLinksInit = function () {
  const links = document.querySelector(".shareiconslist");

  if (!links) {
    return;
  }

  links.addEventListener("click", function (e) {
    e.preventDefault();
    const clicked = e.target.closest(".sharelink--popup");

    if (!clicked) {
      return;
    }

    const shareURL = clicked.getAttribute("href");
    window.open(shareURL, "share-dialog", "width=550,height=436");
  });
}; // sharingLinksInit();
sharingLinksInit();

/*  ==========================================================================
    GENERAL - LazyLoad - Enable Lazy load for images
    ========================================================================== */

// Lazy load images (or everything with .lazy)
const lazyLoadInstance = new LazyLoad();

/*  ==========================================================================
  GENERAL - Share Icons
========================================================================== */
const socialLinksInit = function () {
  const socialLinks = document.querySelectorAll(".sociallink");

  if (!socialLinks) {
    return;
  }

  socialLinks.forEach(socialLink =>
    socialLink.addEventListener("click", function (e) {
      e.preventDefault();
      const shareURL = this.getAttribute("href");
      var w = 550;
      var h = 550;
      var left = Number(screen.width / 2 - w / 2);
      var tops = Number(screen.height / 2 - h / 2);
      window.open(
        shareURL,
        "share-dialog",
        "resizable=no, width=" + w + ", height=" + h + ", top=" + tops + ", left=" + left + ""
      );
    })
  );
}; // socialLinksInit();
socialLinksInit();

/*  ==========================================================================
  GENERAL - Form Section Progress Bar
========================================================================== */

const setProgressBarWidth = function (progressbar) {
  const sectionstotal = progressbar.dataset.sectionscount;
  const sectionscurrent = progressbar.dataset.sectionscurrent;

  var winScroll = document.body.scrollTop || document.documentElement.scrollTop;
  var height = document.documentElement.scrollHeight - document.documentElement.clientHeight;
  let pagescrolled = (winScroll / height) * 100;
  if (height === 0) {
    pagescrolled = 100;
  }
  let scrolled = 0;
  if (sectionstotal && sectionscurrent && sectionstotal > 1) {
    // if we have a total amount of sections and the current section then scroll per section
    var sectionscroll = 100 / sectionstotal;
    scrolled += (sectionscurrent - 1) * sectionscroll;
    scrolled += (sectionscroll / 100) * pagescrolled;
  } else {
    // if not just scroll using the total percentage
    scrolled = pagescrolled;
  }
  progressbar.querySelector(".applicationheader__progressbar__fill").style.width = scrolled + "%";
};

const progressBarInit = function () {
  const progressbar = document.querySelector(".applicationheader__progressbar");

  if (!progressbar) {
    return;
  }

  window.onscroll = function () {
    setProgressBarWidth(progressbar);
  };
  window.onload = function () {
    setProgressBarWidth(progressbar);
  };
  window.onresize = function () {
    setProgressBarWidth(progressbar);
  };
};

progressBarInit();

/*  ==========================================================================
  GENERAL - FAQs
========================================================================== */

const faqInit = function (questions, itemSelector, openClass) {
  if (!questions.length) {
    return;
  }

  questions.forEach(question =>
    question.addEventListener("click", function () {
      const item = question.closest(itemSelector);
      const panel = document.getElementById(question.getAttribute("aria-controls"));
      const isExpanded = question.getAttribute("aria-expanded") === "true";

      if (!item || !panel) {
        return;
      }

      const currentHeight = panel.getBoundingClientRect().height;

      panel.style.height = currentHeight + "px";
      panel.getBoundingClientRect();

      item.classList.toggle(openClass, !isExpanded);
      question.setAttribute("aria-expanded", String(!isExpanded));
      panel.setAttribute("aria-hidden", String(isExpanded));

      if (isExpanded) {
        window.requestAnimationFrame(function () {
          panel.style.height = "0px";
        });
      } else {
        window.requestAnimationFrame(function () {
          panel.style.height = panel.scrollHeight + "px";
        });
      }

      const onTransitionEnd = function (event) {
        if (event.propertyName !== "height") {
          return;
        }

        panel.removeEventListener("transitionend", onTransitionEnd);

        if (question.getAttribute("aria-expanded") === "true") {
          panel.style.height = "auto";
        }

        Waypoint.refreshAll();
      };

      panel.addEventListener("transitionend", onTransitionEnd);
    })
  );
};

faqInit(
  document.querySelectorAll(".landingpage-faq__question"),
  ".landingpage-faq__item",
  "landingpage-faq__item--open"
);
faqInit(document.querySelectorAll(".formmodule__faq-question"), ".formmodule__faq-item", "formmodule__faq-item--open");

/*  ==========================================================================
  POPUPS (using fancybox V4)
  ========================================================================== */
var popupid = 0;
function setupFancyboxEvents() {
  $(".fancybox-answer[data-fancybox]").fancybox({
    dragToClose: false,
    infinite: false,
    autoFocus: false,
    touch: false,
    baseClass: "fancybox--page fancybox--page--" + popupid,
    afterLoad: function (fancybox, instance, slide, current) {
      // Get ".fancybox-content", for this fancybox
      let thisContent = this.$content[0];

      // Re-init lazy load
      lazyLoadInstance.update(); // reinit lazy load after clones

      // Re-init effects
      const fancyboxeffects = thisContent.querySelectorAll(".fancybox-content .effect");
      effectsInit(fancyboxeffects);
      Waypoint.refreshAll();

      var current_popupid = popupid;
      popupid++;

      $(".fancybox--page")
        .not(".fancybox--page--" + current_popupid)
        .remove();

      const closeBtn = thisContent.querySelector(".fancybox-close-custom");
      closeBtn.addEventListener("click", function () {
        fancybox.close();
      });
      // Re setup on any links within the fancybox!
      setupFancyboxEvents();
    }
  });
}

setupFancyboxEvents();

/*  ==========================================================================
  GENERAL - Lead Capture Dropdown Mobile
========================================================================== */

const toggleBtn = document.querySelector(".leadcapture__nav__toggle");
const dropdown = document.querySelector(".leadcapture__dropdown");
const mobileMenu = document.querySelector(".leadcapture__mobile");
const leadcaptureSidebarOpenClass = "leadcapture-sidebar-open";
let leadcaptureScrollPosition = 0;

function leadcaptureLockPage() {
  leadcaptureScrollPosition = window.scrollY;
  body.style.setProperty("--leadcapture-scroll-lock-offset", `-${leadcaptureScrollPosition}px`);
  body.classList.add(leadcaptureSidebarOpenClass);
}

function leadcaptureUnlockPage() {
  const documentElement = document.documentElement;
  const originalScrollBehavior = documentElement.style.scrollBehavior;

  documentElement.style.scrollBehavior = "auto";
  body.classList.remove(leadcaptureSidebarOpenClass);
  body.style.removeProperty("--leadcapture-scroll-lock-offset");
  window.scrollTo(0, leadcaptureScrollPosition);

  window.requestAnimationFrame(function () {
    if (originalScrollBehavior) {
      documentElement.style.scrollBehavior = originalScrollBehavior;
    } else {
      documentElement.style.removeProperty("scroll-behavior");
    }
  });
}

function leadcaptureDropdownHeight() {
  if (!dropdown || !mobileMenu) {
    return 0;
  }

  const mobileMenuTop = mobileMenu.getBoundingClientRect().top;
  const mobileNav = mobileMenu.querySelector(".leadcapture__nav");
  const mobileNavHeight = mobileNav ? mobileNav.getBoundingClientRect().height : 0;
  const availableHeight = window.innerHeight - mobileMenuTop - mobileNavHeight;

  return availableHeight > 0 ? availableHeight : 0;
}

function leadcaptureSetDropdownHeight() {
  dropdown.style.maxHeight = `${leadcaptureDropdownHeight()}px`;
}

function leadcaptureCloseDropdown() {
  if (!dropdown || !mobileMenu || !toggleBtn) {
    return;
  }

  dropdown.style.maxHeight = "0px";
  dropdown.classList.remove("is-open");
  mobileMenu.classList.remove("is-open");
  toggleBtn.classList.remove("active");
  toggleBtn.setAttribute("aria-expanded", "false");
  dropdown.setAttribute("aria-hidden", "true");
  dropdown.inert = true;
  leadcaptureUnlockPage();
}

function leadcaptureDropdownInit() {
  if (!toggleBtn) {
    return;
  }

  if (toggleBtn && dropdown) {
    toggleBtn.addEventListener("click", function (e) {
      e.preventDefault();

      if (dropdown.classList.contains("is-open")) {
        leadcaptureCloseDropdown();
      } else {
        dropdown.classList.add("is-open");
        mobileMenu.classList.add("is-open");
        toggleBtn.classList.add("active");
        toggleBtn.setAttribute("aria-expanded", "true");
        dropdown.setAttribute("aria-hidden", "false");
        dropdown.inert = false;
        leadcaptureLockPage();
        window.requestAnimationFrame(leadcaptureSetDropdownHeight);
      }
    });
  }
}

leadcaptureDropdownInit();

if (mobileMenu) {
  mobileMenu.addEventListener("click", function (e) {
    if (e.target === mobileMenu && mobileMenu.classList.contains("is-open")) {
      leadcaptureCloseDropdown();
    }
  });
}

window.addEventListener(
  "resize",
  function () {
    if (dropdown && dropdown.classList.contains("is-open")) {
      if (window.innerWidth >= Number(gridSizes.lg)) {
        leadcaptureCloseDropdown();
      } else {
        leadcaptureSetDropdownHeight();
      }
    }
  },
  true
);

/*  ==========================================================================
    AJAX - AJAX load more / paging
    ========================================================================== */

const loadmoreBtn = document.querySelector(".paging__loadmore");
const loadmoreContainer = document.querySelector(".loadmore-container");

const loadmoreLoadPosts = function () {
  const button = this;
  const data = {
    action: "loadmore",
    query: php_variables.posts, // that's how we get params from wp_localize_script() function
    page: php_variables.current_page
  };
  let buttonText; // create variable to store button text

  // This AJAX triggers a PHP hook within functions-ajax.php called ajax_loadmore_handler
  $.ajax({
    url: php_variables.ajax_url, // AJAX handler
    data: data,
    type: "POST",
    beforeSend: function (xhr) {
      buttonText = button.textContent; // store current button text
      button.textContent = "Loading..."; // change the button text, to let the user know we are loading more posts
    },
    success: function (data) {
      if (data) {
        button.textContent = buttonText; // set back to previous button text
        loadmoreContainer.innerHTML = loadmoreContainer.innerHTML + data; // insert new posts to the loadmore-container, this should be the row that includes the posts
        php_variables.current_page++;
        // if last page, remove the button..
        if (parseInt(php_variables.current_page) === parseInt(php_variables.max_page)) {
          button.remove();
        }
        // Re-init links to make sure linklines on newly loaded content still work
        linksInit();
        // Re-init lazy load
        lazyLoadInstance.update(); // reinit lazy load after clones
        // Re-init effects
        effectsInit();
      } else {
        button.remove(); // if no data, remove the button as well
      }
    }
  });
}; // loadmoreLoadPosts();

const loadmoreInit = function () {
  if (!loadmoreBtn) {
    return;
  }

  loadmoreBtn.addEventListener("click", loadmoreLoadPosts);
}; // loadmoreInit();
loadmoreInit();

/*  ==========================================================================
    Scroll effects
    ========================================================================== */

const effects = document.querySelectorAll(".effect");

const effectsInit = function () {
  if (!effects) {
    return;
  }

  effects.forEach(function (val) {
    const waypoints = new Waypoint({
      element: val,
      handler: function (direction) {
        if (direction === "down") {
          val.classList.add("effect--ready");
        } else {
          val.classList.remove("effect--ready");
        }
      },
      offset: "90%"
    });
  });
}; // effectsInit();
effectsInit();

/*  ==========================================================================
    Floating FAQs button
    ========================================================================== */

const faqsbutton = document.querySelector(".btn--floatingfaqs");
const faqsModule = document.querySelector(".formmodule--faqs");

const faqBtnHide = function () {
  if (!faqsbutton || !faqsModule) {
    return;
  }

  const waypoints = new Waypoint({
    element: faqsModule,
    handler: function (direction) {
      if (direction === "down") {
        faqsbutton.classList.add("hide");
      } else {
        faqsbutton.classList.remove("hide");
      }
    },
    offset: "100%"
  });
}; // faqBtnHide();
faqBtnHide();

/*  ==========================================================================
Background Gradient Animation
========================================================================== */
/* jshint ignore:start */

const backgroundGradientContainers = document.querySelectorAll("[data-background-gradient]");

const backgroundGradientInit = function (containers) {
  if (!containers || !containers.length) {
    return;
  }

  const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
  const touchDevice = window.matchMedia("(hover: none), (pointer: coarse)").matches;
  const springStrength = 26;
  const states = [];
  const stateByContainer = new Map();
  let frame = null;

  // Keep the gradient still when reduced motion is enabled.
  if (reduceMotion.matches) {
    return;
  }

  const updateBounds = (state, updatePosition) => {
    const containerBounds = state.container.getBoundingClientRect();
    const trackerBounds = state.tracker.getBoundingClientRect();

    state.baseX =
      ((containerBounds.left + containerBounds.width * 0.25694 - trackerBounds.left) / trackerBounds.width) * 100;
    state.baseY =
      ((containerBounds.top + containerBounds.width * 0.07798 - trackerBounds.top) / trackerBounds.height) * 100;
    state.trackerBounds = trackerBounds;

    if (updatePosition) {
      state.gradient.style.setProperty("--background-gradient-field-x", `${state.baseX.toFixed(3)}%`);
      state.gradient.style.setProperty("--background-gradient-field-y", `${state.baseY.toFixed(3)}%`);
    }
  };

  const isSettled = state =>
    Math.abs(state.targetX - state.currentX) <= 0.1 &&
    Math.abs(state.targetY - state.currentY) <= 0.1 &&
    Math.abs(state.velocityX) <= 0.1 &&
    Math.abs(state.velocityY) <= 0.1;

  const render = timestamp => {
    let keepAnimating = false;
    const splashIsActive = document.documentElement.classList.contains("splash-active");

    states.forEach(state => {
      if (splashIsActive || !state.isVisible) {
        state.lastFrameTime = null;
        return;
      }

      if (!touchDevice && isSettled(state)) {
        return;
      }

      if (!state.trackerBounds) {
        updateBounds(state, false);
      }

      // Touch screens keep the original automatic movement instead of following a pointer.
      if (touchDevice) {
        if (state.ambientStartTime === null) {
          state.ambientStartTime = timestamp;
        }

        const ambientTime = (timestamp - state.ambientStartTime) / 1000 + state.index * 1.75;
        state.targetX = Math.sin(ambientTime * 0.48) * 13 + Math.sin(ambientTime * 0.19) * 5;
        state.targetY = 4 + (Math.cos(ambientTime * 0.39) + 1) * 10 + (Math.sin(ambientTime * 0.16) + 1) * 3.5;
      }

      const elapsed = state.lastFrameTime === null ? 16.67 : Math.min(timestamp - state.lastFrameTime, 32);
      const delta = elapsed / 1000;
      const damping = Math.exp(-8.5 * delta);
      state.lastFrameTime = timestamp;

      state.velocityX += (state.targetX - state.currentX) * springStrength * delta;
      state.velocityY += (state.targetY - state.currentY) * springStrength * delta;
      state.velocityX *= damping;
      state.velocityY *= damping;
      state.currentX += state.velocityX * delta;
      state.currentY += state.velocityY * delta;

      const stretchX = 1 + Math.min(Math.abs(state.velocityX) / 1800, 0.055);
      const stretchY = 1 + Math.min(Math.abs(state.velocityY) / 1500, 0.05);
      const tilt = Math.max(-2.5, Math.min(2.5, state.velocityX / 42));

      state.gradient.style.setProperty(
        "--background-gradient-field-x",
        `${(state.baseX + state.currentX).toFixed(3)}%`
      );
      state.gradient.style.setProperty(
        "--background-gradient-field-y",
        `${(state.baseY + state.currentY).toFixed(3)}%`
      );
      state.gradient.style.setProperty("--background-gradient-stretch-x", stretchX.toFixed(4));
      state.gradient.style.setProperty("--background-gradient-stretch-y", stretchY.toFixed(4));
      state.gradient.style.setProperty("--background-gradient-tilt", `${tilt.toFixed(2)}deg`);

      if (touchDevice || !isSettled(state)) {
        keepAnimating = true;
      } else {
        state.velocityX = 0;
        state.velocityY = 0;
        state.lastFrameTime = null;
      }
    });

    frame = keepAnimating ? window.requestAnimationFrame(render) : null;
  };

  const requestRender = () => {
    if (frame === null) {
      frame = window.requestAnimationFrame(render);
    }
  };

  containers.forEach((container, index) => {
    const tracker = container.querySelector(".background-gradient");
    const gradient = container.querySelector(".background-gradient__field");

    if (!tracker || !gradient) {
      return;
    }

    const state = {
      ambientStartTime: null,
      baseX: 34.81,
      baseY: 27.52,
      container,
      currentX: 0,
      currentY: 0,
      gradient,
      index,
      isVisible: true,
      lastFrameTime: null,
      targetX: 0,
      targetY: 0,
      tracker,
      trackerBounds: null,
      velocityX: 0,
      velocityY: 0
    };

    states.push(state);
    stateByContainer.set(container, state);
    updateBounds(state, true);

    if (!touchDevice) {
      container.addEventListener("pointerenter", () => updateBounds(state, isSettled(state)), { passive: true });

      container.addEventListener(
        "pointermove",
        event => {
          if (!state.trackerBounds) {
            updateBounds(state, false);
          }

          state.targetX = ((event.clientX - state.trackerBounds.left) / state.trackerBounds.width) * 100 - state.baseX;
          state.targetY = ((event.clientY - state.trackerBounds.top) / state.trackerBounds.height) * 100 - state.baseY;
          requestRender();
        },
        { passive: true }
      );

      container.addEventListener("pointerleave", () => {
        state.trackerBounds = null;
      });
    }
  });

  if ("IntersectionObserver" in window) {
    const visibilityObserver = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          const state = stateByContainer.get(entry.target);

          if (!state) {
            return;
          }

          state.isVisible = entry.isIntersecting;
          state.tracker.classList.toggle("background-gradient--paused", !state.isVisible);

          if (state.isVisible) {
            state.trackerBounds = null;
            state.lastFrameTime = null;
            requestRender();
          }
        });
      },
      { rootMargin: "100px 0px" }
    );

    states.forEach(state => visibilityObserver.observe(state.container));
  }

  const splashElement = document.querySelector(".splash");

  if (splashElement) {
    splashElement.addEventListener("splash:dismissed", requestRender, { once: true });
  }

  const invalidateBounds = () => {
    states.forEach(state => {
      state.trackerBounds = null;
    });
  };

  window.addEventListener("resize", invalidateBounds, { passive: true });

  if (!touchDevice) {
    window.addEventListener("scroll", invalidateBounds, { passive: true });
  }

  if (touchDevice) {
    requestRender();
  }
}; // backgroundGradientInit();
backgroundGradientInit(backgroundGradientContainers);
/* jshint ignore:end */

/*  ==========================================================================
	NAVIGATION - application sidebar dropdown
	========================================================================== */

const sidebarNav = document.querySelector(".sidebar__content");
const sidebarHeaderBd = document.querySelector(".sidebar__header .sidebar__bd");
const sidebarToggle = document.querySelector(".sidebar__btn__navbtn");
const sidebarOpenClass = "sidebar-open";

const sidebarSetHeight = function () {
  if (!sidebarNav || !sidebarHeaderBd) {
    return;
  }

  const sidebarNavHeight = window.innerHeight - sidebarHeaderBd.getBoundingClientRect().height;
  sidebarNav.style.height = `${sidebarNavHeight}px`;
}; // sidebarSetHeight()

const sidebarInit = function () {
  if (!sidebarNav || !sidebarHeaderBd || !sidebarToggle) {
    return;
  }

  // Open sidebar on click the toggle
  sidebarToggle.addEventListener("click", function (e) {
    e.preventDefault();
    let sidebarNavHeight = 0;
    if (!body.classList.contains(sidebarOpenClass)) {
      // IT'S NOT OPEN...
      sidebarSetHeight();
      body.classList.add(sidebarOpenClass);
    } else {
      // IT'S OPEN...
      sidebarNav.style.height = 0;
      body.classList.remove(sidebarOpenClass);
    }
  });
}; // sidebarInit()
sidebarInit();

// On resize check sidebar height is still right
const sidebarResize = function () {
  let sidebarNavHeight = 0;
  if (sidebarNav && sidebarHeaderBd && body.classList.contains(sidebarOpenClass)) {
    sidebarSetHeight();
  }
}; // sidebarResize()

window.addEventListener(
  "resize",
  function (event) {
    sidebarResize();
  },
  true
);

/*  ==========================================================================
	NAVIGATION - mobnav
	========================================================================== */

const mobnav = document.querySelector(".mobnav");
const mobnavBd = document.querySelector(".mobnav__bd");
const siteHeaderBd = document.querySelector(".siteheader__bd");
const mobnavToggle = document.querySelector(".mobnav-toggle");
const mobnavOpenclass = "mobnavopen";

const mobnavSetHeight = function () {
  const mobnavMaxHeight = window.innerHeight - siteHeaderBd.getBoundingClientRect().height;
  const mobnavHeight = mobnavBd.getBoundingClientRect().height + siteHeaderBd.getBoundingClientRect().height;
  let setHeight = mobnavMaxHeight;
  if (mobnavHeight < mobnavMaxHeight) {
    setHeight = mobnavHeight;
  }
  mobnav.style.height = `${setHeight}px`;
}; // mobnavSetHeight()

const mobnavInit = function () {
  // Open mobnav on click the toggle
  if (mobnavToggle !== null) {
    mobnavToggle.addEventListener("click", function (e) {
      e.preventDefault();

      let mobnavHeight = 0;
      if (!body.classList.contains(mobnavOpenclass)) {
        // IT'S NOT OPEN...
        mobnavSetHeight();
        body.classList.add(mobnavOpenclass);
      } else {
        // IT'S OPEN...
        mobnav.style.height = 0;
        body.classList.remove(mobnavOpenclass);
      }
    });
  }
}; // mobnavInit()
mobnavInit();

// On resize check mobnav height is still right
const mobnavResize = function () {
  let mobnavHeight = 0;
  if (body.classList.contains(mobnavOpenclass)) {
    mobnavSetHeight();
  }
}; // mobnavResize()

window.addEventListener(
  "resize",
  function (event) {
    mobnavResize();
  },
  true
);

/*  ==========================================================================
	APPLICATION - Forms
	========================================================================== */

const leadCaptureForm = document.querySelector("#leadcapture");
const emailVerificationPopup = document.querySelector(".popup--emailverification");
let emailVerificationPopupTrigger = null;
const emailVerificationForm = document.querySelector("#emailverification");
const foundSavedPopup = document.querySelector(".popup--foundsaved");
let foundSavedPopupTrigger = null;
let foundSavedPopupOriginalIntroContent = "";
const fullAppForm = document.querySelector("#fullapplication");
const appSections = document.querySelectorAll(".appform__section");
const validationPopup = document.querySelector(".popup--validation");
let validationPopupTrigger = null;
const savePopup = document.querySelector(".popup--saveforlater");
const retrieveSavedForm = document.querySelector("#retrievesaved");
const retrieveSavedVerificationForm = document.querySelector("#retrievesaved-verification");

const formModuleHiddenClass = "formmodule--hidden";
const formFieldClass = ".appform__field";
const formFieldInputErrorClass = ".appform__field__input--error";

const validationCookieName = "ef_validation_enabled";
const recaptchaSiteKey = "6Lc6DF4lAAAAAAitK_PMqBwuL-LrVBC1CVQ4HMDG";
const phoneInputLoadRetryDelay = 100;
const phoneInputLoadMaxAttempts = 100;

// create variable to determine whether to show exit alert on beforeunload
let exitAlert = true;

/*  ==========================================================================
	APPLICATION - Validation setup
  -- This uses Just Validate - https://just-validate.dev/docs/intro
	========================================================================== */

const validatorSettings = {
  errorFieldCssClass: "appform__field__input--error",
  errorLabelCssClass: "appform__field__error__msg",
  validateBeforeSubmitting: true,
  lockForm: false
};

function setupRecaptcha(action) {
  const recaptchaResponse = document.getElementById("recaptchaResponse");

  if (!recaptchaResponse) {
    return;
  }

  if (typeof window.grecaptcha === "undefined") {
    window.grecaptcha = {
      ready: function (callback) {
        const recaptchaConfigName = "___grecaptcha_cfg";
        window[recaptchaConfigName] = window[recaptchaConfigName] || {};
        window[recaptchaConfigName].fns = window[recaptchaConfigName].fns || [];
        window[recaptchaConfigName].fns.push(callback);
      }
    };
  }

  window.grecaptcha.ready(function () {
    window.grecaptcha
      .execute(recaptchaSiteKey, { action: action })
      .then(function (token) {
        recaptchaResponse.value = token;
      })
      .catch(function () {
        recaptchaResponse.value = "";
      });
  });
}

// Check for valid URLs
function checkUrl(string) {
  if (string) {
    const pattern = new RegExp(
      "^([a-zA-Z]+:\\/\\/)?" + // protocol
        "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name
        "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR IP (v4) address
        "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
        "(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
        "(\\#[-a-z\\d_]*)?$", // fragment locator
      "i"
    );
    return pattern.test(string);
  } else {
    return true;
  }
}

function checkPhoneNumber(string) {
  if (string) {
    const phonePattern = new RegExp("^(\\+)?([ 0-9]){5,16}$", "i");
    return phonePattern.test(string);
  } else {
    return true;
  }
}

function validateForm(theForm, validator, removeField = false) {
  if (validator) {
    // Get all fields in the form
    const formFields = theForm.querySelectorAll(formFieldClass);

    // loop through each form field and build validation rules for each
    if (formFields.length) {
      formFields.forEach(formField => {
        // dont validate hidden fields
        const formFieldInput = formField.querySelector(".appform__field__input");
        const formFieldGroup = formField.querySelector(".appform__field__group");
        if (
          !formField.closest(".formmodule") ||
          !formField.closest(".formmodule").classList.contains(formModuleHiddenClass)
        ) {
          let fieldRules = [];
          // Get all fields inputs (this is also used to pull textarea's and select fields which is why we use a class rather than "input")
          // Required fields
          if (formField.classList.contains("appform__field--required")) {
            const requiredRule = {
              rule: "required"
            };

            if (theForm === leadCaptureForm) {
              requiredRule.errorMessage = "This field is required";
            }

            fieldRules.push(requiredRule);
          }
          // Email validation
          if (formField.classList.contains("appform__field--email")) {
            fieldRules.push({
              rule: "email",
              errorMessage: "Please enter a valid email"
            });
          }
          // URL validation
          if (formField.classList.contains("appform__field--url")) {
            fieldRules.push({
              validator: (value, fields) => {
                return checkUrl(value);
              },
              errorMessage: "Please enter a valid URL, it must be the full url"
            });
          }
          // Phone validation
          if (formField.classList.contains("appform__field--tel")) {
            fieldRules.push({
              validator: (value, fields) => {
                return checkPhoneNumber(value);
              },
              errorMessage: "Please enter a valid phone number"
            });
          }
          // Phone validation
          if (formField.classList.contains("appform__field--text")) {
            if (typeof formField.dataset.max !== "undefined") {
              fieldRules.push({
                validator: (value, fields) => {
                  return value.length < formField.dataset.max;
                },
                errorMessage: "Must be " + formField.dataset.max + " characters in length"
              });
            }
          }
          // Code validation
          if (formField.classList.contains("appform__field--code")) {
            fieldRules.push({
              rule: "minLength",
              value: 5
            });
            fieldRules.push({
              rule: "maxLength",
              value: 5
            });
            fieldRules.push({
              rule: "number"
            });
          }
          // Number validation
          if (formField.classList.contains("appform__field--number")) {
            fieldRules.push({
              rule: "number"
            });
          }

          // if a field requires validation then add that to the validator
          if (fieldRules.length) {
            let errorsContainer = formFieldInput.closest(".appform__field").querySelector(".appform__field__error");
            const fieldConfig = {
              errorsContainer: errorsContainer
            };
            const isApplicationField = theForm === leadCaptureForm || theForm.closest("#fullapplication");

            if (isApplicationField) {
              fieldConfig.errorLabelCssClass = "appform__field__error__msg heading-xsml";
            }

            if (formFieldGroup && formField.classList.contains("appform__field--required")) {
              // Groups are created for checkbox list's and radio lists
              validator.addRequiredGroup("#" + formFieldGroup.id, "Please select atleast 1 option", fieldConfig);
            } else {
              validator.addField(formFieldInput, fieldRules, fieldConfig);
            }
          }
        } else if (removeField) {
          // remove field, for fields being hidden by conditional logicx
          if (formFieldGroup && formField.classList.contains("appform__field--required")) {
            // Groups are created for checkbox list's and radio lists
            validator.removeGroup("#" + formFieldGroup.id);
          } else {
            validator.removeField(formFieldInput);
          }
        }
      });
    }
  }
}

/*  ==========================================================================
	APPLICATION - Scroll to first error
	========================================================================== */

function scrollToFirstError() {
  let firstError = document.querySelectorAll(".appform__field__input--error")[0];
  if (firstError) {
    let firstErrorField = firstError.closest(".appform__field");
    if (firstErrorField) {
      firstErrorField.scrollIntoView({ block: "center" });
    }
  }
}

/*  ==========================================================================
	APPLICATION - Get all field data
	========================================================================== */

function getFieldData(theForm) {
  const formFields = theForm.querySelectorAll(formFieldClass);
  const formData = [];
  // loop through each form field and build validation rules for each
  if (formFields.length) {
    formFields.forEach(formField => {
      let fieldData = {};

      // Get unique ID
      let fieldID = formField.dataset.fieldid;
      if (fieldID) {
        fieldData.uniqueID = fieldID;
      }

      // Get Field Key
      let fieldKey = formField.dataset.fieldkey;
      if (fieldKey) {
        fieldData.fieldKey = fieldKey;
      }

      // Get field name (label)
      let fieldLabel = formField.querySelector(".appform__field__label__text");
      if (fieldLabel && fieldLabel.textContent) {
        fieldData.fieldName = fieldLabel.textContent;
      }

      // check if form field hidden by conditional logic
      if (
        !formField.closest(".formmodule") ||
        !formField.closest(".formmodule").classList.contains(formModuleHiddenClass)
      ) {
        // If not hidden...

        // Get field value
        if (formField.classList.contains("appform__field--checkbox")) {
          let fieldValue = formField.querySelector(".appform__field__input").checked;
          if (fieldValue) {
            fieldData.fieldValue = 1;
          } else {
            fieldData.fieldValue = 0;
          }
        } else if (formField.classList.contains("appform__field--checkbox-list")) {
          let fieldValues = [];
          let fieldInputs = formField.querySelectorAll(".appform__field__input");
          if (fieldInputs) {
            fieldInputs.forEach(function (fieldInput) {
              if (fieldInput.checked) {
                fieldValues.push(fieldInput.value);
              }
            });
          }
          if (fieldValues) {
            fieldData.fieldValue = fieldValues.join(",");
          } else {
            fieldData.fieldValue = 0;
          }
        } else if (formField.classList.contains("appform__field--radio-buttons")) {
          let fieldInputs = formField.querySelectorAll(".appform__field__input");
          if (fieldInputs) {
            fieldInputs.forEach(function (fieldInput) {
              if (fieldInput.checked) {
                fieldData.fieldValue = fieldInput.value;
              }
            });
          }
        } else if (formField.classList.contains("appform__field--tel")) {
          let fieldInput = formField.querySelector(".appform__field__input");
          let iti = window.intlTelInputGlobals ? window.intlTelInputGlobals.getInstance(fieldInput) : null;
          let fieldValue = iti ? iti.getNumber() : fieldInput.value;
          if (fieldValue) {
            fieldData.fieldValue = fieldValue;
          }
        } else {
          let fieldValue = formField.querySelector(".appform__field__input").value;
          if (fieldValue) {
            fieldData.fieldValue = fieldValue;
          } else {
            fieldData.fieldValue = "";
          }
        }
      }
      if (fieldData.uniqueID) {
        formData.push(fieldData);
      }
    });
  }

  return formData;
}

/*  ==========================================================================
	APPLICATION - Show form error (global, not field specific)
	========================================================================== */

function showFormError(theForm, errorCode, customMessage = false) {
  theForm.querySelector(".appform__error__code").innerHTML = errorCode;
  theForm.querySelector(".appform__error").classList.add("appform__error--show");
  if (errorCode === "6741" || errorCode === "6742" || errorCode === "6743") {
    customMessage =
      "ReCAPTCHA verification failed. Please ensure you're using a <a href='https://support.google.com/recaptcha?sjid=11985947536668806223-EU#6223828' target='_blank' rel='noopener noreferrer'><span class='linkline'>ReCAPTCHA supported browser</span></a>, clear your cookies / cache, and try again later. If the problem persists, contact us at <a href='mailto:applications@joinef.com'><span class='linkline'>applications@joinef.com</span></a>.";
  }
  if (customMessage) {
    theForm.querySelector(".appform__error__msg--custom").innerHTML = customMessage;
    theForm.querySelector(".appform__error__msg--custom").classList.add("appform__error__msg--show");
    theForm.querySelector(".appform__error__msg--default").classList.remove("appform__error__msg--show");
  } else {
    theForm.querySelector(".appform__error__msg--custom").classList.remove("appform__error__msg--show");
    theForm.querySelector(".appform__error__msg--default").classList.add("appform__error__msg--show");
  }
}

/*  ==========================================================================
	APPLICATION - Show form success (global, not field specific)
	========================================================================== */

function showFormSuccess(theForm, customMessage) {
  theForm.querySelector(".appform__success").classList.add("appform__success--show");
  if (customMessage) {
    theForm.querySelector(".appform__success").innerHTML = customMessage;
  } else {
    theForm.querySelector(".appform__success").innerHTML = "success!";
  }
}

/*  ==========================================================================
	APPLICATION - Show loading e.g. disable submit etc whilst form submits
	========================================================================== */

function showFormLoading(theForm) {
  if (theForm.querySelector(".appform__backbtn")) {
    theForm.querySelector(".appform__backbtn").classList.add("btn--disabled");
  }
  if (theForm.querySelector(".appform__submitbtn")) {
    theForm.querySelector(".appform__submitbtn").classList.add("btn--disabled");
  }
}

function resetFormLoading(theForm) {
  if (theForm.querySelector(".appform__backbtn")) {
    theForm.querySelector(".appform__backbtn").classList.remove("btn--disabled");
  }
  if (theForm.querySelector(".appform__submitbtn")) {
    theForm.querySelector(".appform__submitbtn").classList.remove("btn--disabled");
  }
}

/*  ==========================================================================
	APPLICATION - Lead Capture Form
	========================================================================== */

// Submit AJAX request
function submitLeadCapture(formData) {
  const appFormData = new FormData();

  appFormData.append("action", "applications__submit_leadcapture");

  const leadcapture_checkbox_data = JSON.stringify(
    formData.filter(function (x) {
      return x.uniqueID.includes("gdprcheckbox_");
    })
  );

  appFormData.append("firstname", formData.filter(x => x.uniqueID === "firstname")[0].fieldValue);
  appFormData.append("lastname", formData.filter(x => x.uniqueID === "lastname")[0].fieldValue);
  appFormData.append("email", formData.filter(x => x.uniqueID === "email")[0].fieldValue);
  appFormData.append("phone", formData.filter(x => x.uniqueID === "phone")[0].fieldValue);
  appFormData.append("linkedin_url", formData.filter(x => x.uniqueID === "linkedin_url")[0].fieldValue);
  appFormData.append("application_postid", formData.filter(x => x.uniqueID === "postid")[0].fieldValue);
  appFormData.append("application_name", formData.filter(x => x.uniqueID === "appname")[0].fieldValue);
  appFormData.append("application_location", formData.filter(x => x.uniqueID === "applocation")[0].fieldValue);
  appFormData.append("application_category", formData.filter(x => x.uniqueID === "appcategory")[0].fieldValue);
  appFormData.append("application_start_date", formData.filter(x => x.uniqueID === "appstartdate")[0].fieldValue);
  appFormData.append("application_cohort", formData.filter(x => x.uniqueID === "appcohort")[0].fieldValue);
  appFormData.append("application_type", formData.filter(x => x.uniqueID === "apptype")[0].fieldValue);
  appFormData.append("utm_source", formData.filter(x => x.uniqueID === "utm_source")[0].fieldValue);
  appFormData.append("utm_medium", formData.filter(x => x.uniqueID === "utm_medium")[0].fieldValue);
  appFormData.append("utm_campaign", formData.filter(x => x.uniqueID === "utm_campaign")[0].fieldValue);
  appFormData.append("utm_content", formData.filter(x => x.uniqueID === "utm_content")[0].fieldValue);

  appFormData.append("recaptcha_response", document.getElementById("recaptchaResponse").value);
  appFormData.append("leadcapture_checkboxes", leadcapture_checkbox_data);

  $.ajax({
    type: "POST",
    url: php_variables.ajax_url, // AJAX handler
    data: appFormData,
    processData: false,
    contentType: false,
    beforeSend: function () {
      showFormLoading(leadCaptureForm);
    },
    success: function (data) {
      let data_json = JSON.parse(data);
      let success = data_json.success;
      // Close found saved popup (if its open)
      resetFoundSavedPopup();
      if (success) {
        // sucess form submitted?
        let user_app_id = data_json.user_app_id;
        if (user_app_id) {
          displayVerificationPopup(data_json.user_email);
        } else {
          showFormError(leadCaptureForm, "6706");
        }
      } else {
        let error_code = data_json.error_code;
        showFormError(leadCaptureForm, error_code);
      }
    }
  });
}

// Check for saved application before submitting lead captures
function checkForSaved(formData) {
  const appFormData = new FormData();

  appFormData.append("action", "applications__check_for_saved");
  appFormData.append("email", formData.filter(x => x.uniqueID === "email")[0].fieldValue);
  appFormData.append("check_on_lead_capture", true);

  // check for saved app
  $.ajax({
    type: "POST",
    url: php_variables.ajax_url, // AJAX handler
    data: appFormData,
    processData: false,
    contentType: false,
    beforeSend: function () {
      showFormLoading(leadCaptureForm);
    },
    success: function (data) {
      let data_json = JSON.parse(data);
      let success = data_json.success;
      if (success) {
        // found saved, so display popup to confirm user wants to proceed with application
        displayFoundSavedPopup(formData, data_json.email, data_json.user_app_postname);
      } else {
        // Not found saved, continue with application
        submitLeadCapture(formData);
      }
    }
  });
}

// Init form & setup validation
function initLeadCaptureForm() {
  if (leadCaptureForm) {
    // Setup validation
    const leadCaptureValidator = new JustValidate(leadCaptureForm, validatorSettings);
    validateForm(leadCaptureForm, leadCaptureValidator);

    setupRecaptcha("leadcapture");

    // Setup submit event listener
    leadCaptureForm.addEventListener("submit", function (e) {
      if (!leadCaptureValidator.isValid) {
        // if not valid yet, stop form submit
        e.preventDefault();
        scrollToFirstError();
      } else {
        // once valid, get form data & submit form
        const leadCaptureFormData = getFieldData(leadCaptureForm);
        if (leadCaptureFormData.length) {
          checkForSaved(leadCaptureFormData);
        } else {
          showFormError(leadCaptureForm, "6701");
        }
      }
    });
  }
}

initLeadCaptureForm();

/*  ==========================================================================
	APPLICATION - Full Application Form
	========================================================================== */

// Submit AJAX request
function submitFullApp() {
  // console.log("submitting app");

  // Get lead capture use data from cookie
  if (getCookie("efapp_user_data")) {
    // console.log("cookie found");
    const userData = JSON.parse(getCookie("efapp_user_data"));

    // Get Form data
    let formData = getFieldData(fullAppForm);
    if (formData.length) {
      // console.log("the form does have data");
      // get all other form data
      const appFormData = new FormData();

      appFormData.append("action", "applications__submit_fullapplication");

      appFormData.append("email", userData.email);
      appFormData.append("app_id", userData.app_id);
      appFormData.append("application_postid", userData.application.post_id);
      appFormData.append("recaptcha_response", document.getElementById("recaptchaResponse").value);

      appFormData.append("full_app_data", JSON.stringify(formData));

      // console.log("form data: " + JSON.stringify(formData));

      $.ajax({
        type: "POST",
        url: php_variables.ajax_url, // AJAX handler
        data: appFormData,
        processData: false,
        contentType: false,
        beforeSend: function () {
          showFormLoading(fullAppForm);
        },
        success: function (data) {
          let data_json = JSON.parse(data);
          let success = data_json.success;
          if (success) {
            // sucess form submitted
            let success_redirect = data_json.success_redirect;
            if (success_redirect) {
              // remove validation cookie
              setCookie(validationCookieName, 0, 0);
              // redirect to thank you page
              exitAlert = false;
              window.location.href = success_redirect;
            } else {
              showFormError(fullAppForm, "6716");
            }
          } else {
            let error_code = data_json.error_code;
            showFormError(fullAppForm, error_code);
          }
        }
      });
    } else {
      showFormError(fullAppForm, "6710");
    }
  } else {
    showFormError(fullAppForm, "6711");
  }
}

let appSectionValidators = [];

// Setup validation for sections
function setupSectionValidation() {
  // if we have a validation enabled cookie then setup validation for this section
  if (appSections) {
    appSections.forEach(function (appSection, key) {
      if (!appSectionValidators[appSection.dataset.sectionid]) {
        appSectionValidators[appSection.dataset.sectionid] = new JustValidate(fullAppForm, validatorSettings);
        validateForm(appSection, appSectionValidators[appSection.dataset.sectionid]);
      }
    });
  }
}

// Init form on click of submit
function initFullApp() {
  if (fullAppForm) {
    // Check validation on click of final submit or or "submit" triggered
    let currentSection = document.querySelector(".appform__section--active");
    let currentSectionId = currentSection.dataset.sectionid;
    setupConditionals();
    setupSectionValidation();

    if (getCookie(validationCookieName) && getCookie(validationCookieName) === php_variables.form_id) {
      // If validation enabled on load, request submit to display errors on page
      fullAppForm.requestSubmit();
      scrollToFirstError();
    }

    setupRecaptcha("fullapplication");

    fullAppForm.addEventListener("submit", function (e) {
      e.preventDefault();

      if (fullAppForm.classList.contains("appform--fullapplication--finalpage")) {
        // setup cookie to say validation enabled
        if (!getCookie(validationCookieName) || getCookie(validationCookieName) !== php_variables.form_id) {
          setCookie(validationCookieName, php_variables.form_id, 5);
        }
        validationPopup.querySelectorAll(".popup__errorpage--show").forEach(function (errorPage) {
          errorPage.classList.remove("popup__errorpage--show");
        });
        const sectionValidationPromises = Array.from(appSections).map(function (appSection) {
          const sectionID = appSection.dataset.sectionid;

          return appSectionValidators[sectionID].revalidate().then(function (isValid) {
            if (!isValid) {
              // Display error in popup
              const validationPopupPage = validationPopup.querySelector(".popup__errorpage--" + sectionID);
              validationPopupPage.classList.add("popup__errorpage--show");
              const errorsCount = Object.keys(appSectionValidators[sectionID].errorLabels).length;
              const errorsMsg = errorsCount > 1 ? errorsCount + " errors" : errorsCount + " error";
              validationPopupPage.querySelector(".popup__errorpage__count").textContent = errorsMsg;
            }

            return {
              isValid: isValid,
              sectionID: sectionID
            };
          });
        });

        Promise.all(sectionValidationPromises).then(function (sectionValidationResults) {
          const invalidSections = sectionValidationResults
            .filter(function (sectionValidationResult) {
              return !sectionValidationResult.isValid;
            })
            .map(function (sectionValidationResult) {
              return sectionValidationResult.sectionID;
            });

          if (invalidSections.length === 0) {
            // Submit application
            submitFullApp();
          } else if (invalidSections.length === 1 && invalidSections[0] === currentSectionId) {
            scrollToFirstError();
          } else {
            // Set the CTA in popup to link the user to the first invalid section
            const firstInvalidSection = document.querySelector(
              ".appform__section[data-sectionid='" + invalidSections[0] + "']"
            );
            fullAppForm.action = firstInvalidSection.dataset.sectionurl;
            // Show popup with errors
            validationPopupTrigger = document.activeElement;
            validationPopup.classList.add("popup--custom--show");
            validationPopup.querySelector(".popup__close").focus();
          }
        });
      } else {
        if (appSectionValidators) {
          // Get active section
          if (appSectionValidators[currentSectionId]) {
            if (appSectionValidators[currentSectionId].isValid) {
              // This section is valid so allow a submit to the next section
              exitAlert = false;
              fullAppForm.submit();
            } else {
              // Scroll to first error on page
              scrollToFirstError();
            }
          }
        }
      }
    });
  }
}

initFullApp();

/*  ==========================================================================
	APPLICATION - Create phone number inputs
	========================================================================== */

// init phone inputs
setupPhoneInputs();

function phoneInputHandler(iti, appPhoneInput) {
  document.querySelector("input[name='" + appPhoneInput.name + "-full']").value = iti.getNumber();
}

function setupPhoneCountryList(iti, appPhoneInput) {
  if (iti.isMobile) {
    iti.isMobile = false;
    document.body.classList.remove("iti-mobile");
  }

  appPhoneInput.addEventListener("open:countrydropdown", function () {
    const inputWidth = `${appPhoneInput.getBoundingClientRect().width}px`;

    if (iti.dropdown) {
      iti.dropdown.style.width = inputWidth;
    }

    if (iti.countryList) {
      iti.countryList.style.width = inputWidth;
      iti.countryList.style.maxWidth = inputWidth;
    }
  });
}

function setupPhoneInputs(loadAttempt = 0) {
  const appPhoneInputs = document.querySelectorAll(".appform__field--tel .appform__field__input");

  if (!appPhoneInputs.length) {
    return;
  }

  if (typeof window.intlTelInput !== "function") {
    if (loadAttempt < phoneInputLoadMaxAttempts) {
      window.setTimeout(function () {
        setupPhoneInputs(loadAttempt + 1);
      }, phoneInputLoadRetryDelay);
    }

    return;
  }

  const initialisePhoneInputs = function (initialCountry) {
    appPhoneInputs.forEach(function (appPhoneInput) {
      if (appPhoneInput.dataset.phoneInputInitialised === "true") {
        return;
      }

      let iti = window.intlTelInput(appPhoneInput, {
        initialCountry: initialCountry,
        separateDialCode: true,
        autoPlaceholder: false,
        utilsScript: "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/utils.js"
      });
      appPhoneInput.dataset.phoneInputInitialised = "true";
      setupPhoneCountryList(iti, appPhoneInput);
      // on load, country change or user typing number update the hidden full number field so that the country code gets posted to other pages
      appPhoneInput.addEventListener("countrychange", function () {
        // do something with iti.getSelectedCountryDat;a()
        phoneInputHandler(iti, appPhoneInput);
      });
      appPhoneInput.addEventListener("input", function () {
        // do something with iti.getSelectedCountryData()
        phoneInputHandler(iti, appPhoneInput);
      });
    });
  };

  if (!window.geoip_detect || typeof window.geoip_detect.get_info !== "function") {
    initialisePhoneInputs("gb");
    return;
  }

  window.geoip_detect
    .get_info()
    .then(function (record) {
      const initialCountry = record.error() ? "gb" : record.get("country.iso_code", "gb");
      initialisePhoneInputs(initialCountry);
    })
    .catch(function () {
      initialisePhoneInputs("gb");
    });
}

/*  ==========================================================================
	APPLICATION - Textareas
	========================================================================== */

setupTextareas();

function setupTextareas() {
  const appTextareas = document.querySelectorAll(".appform__field--textarea textarea");
  if (appTextareas.length) {
    // Create autoresizing textarea inputs
    appTextareas.forEach(function (appTextarea) {
      appTextarea.setAttribute("style", "height:" + appTextarea.scrollHeight + "px;overflow-y:hidden;");
      appTextarea.addEventListener(
        "input",
        function () {
          onTextareaInput(appTextarea);
        },
        false
      );
      onTextareaInput(appTextarea);
      // // Create word count displays on textarea (for max-words)
      // $(appTextarea).textareaCounter();
    });
  }
}

function onTextareaInput(thisTextarea) {
  // Update height when text gets bigger
  thisTextarea.style.height = 0;
  thisTextarea.style.height = thisTextarea.scrollHeight + "px";

  // Update counter
  let countertext = $(thisTextarea).closest(".appform__field").find(".appform__field__countertext");
  let countertextNum = $(countertext).find(".appform__field__countertext__livenum");
  let wordLimit = $(thisTextarea).data("maxwords");
  let text = $(thisTextarea).val();
  let wordcount = 0;
  if (text !== "") {
    wordcount = $.trim(text).split(" ").length;
  }
  if (wordcount > wordLimit) {
    $(countertext).addClass("appform__field__countertext--error");
    let limited = $.trim(text).split(" ", wordLimit);
    limited = limited.join(" ");
    $(thisTextarea).val(limited);
    // Update textarea height after cutting down text
    thisTextarea.style.height = 0;
    thisTextarea.style.height = thisTextarea.scrollHeight + "px";
    countertextNum.html(wordLimit);
  } else {
    $(countertext).removeClass("appform__field__countertext--error");
    countertextNum.html(wordcount);
  }
}

/*  ==========================================================================
	APPLICATION - Override sidebar & back button links to trigger form to submit 
  -- this allows us to keep data between page changes
	========================================================================== */

const navigationBtns = document.querySelectorAll(".btn--navigate");

if (navigationBtns) {
  navigationBtns.forEach(function (navigationBtn) {
    navigationBtn.addEventListener("click", function (e) {
      e.preventDefault();
      if (fullAppForm) {
        // Update action for form to post user data to correct page
        fullAppForm.action = navigationBtn.href;
        exitAlert = false;
        fullAppForm.submit();
      }
    });
  });
}
/*  ==========================================================================
	APPLICATION - Submit / Next Buttons
	========================================================================== */

const submitBtns = document.querySelectorAll(".btn--submit");

if (submitBtns) {
  submitBtns.forEach(function (submitBtn) {
    submitBtn.addEventListener("click", function (e) {
      e.preventDefault();
      if (fullAppForm) {
        if (
          fullAppForm.classList.contains("appform--fullapplication--finalpage") ||
          (getCookie(validationCookieName) && getCookie(validationCookieName) === php_variables.form_id)
        ) {
          // if validation enabled, request submit to allow form validation before submitting
          fullAppForm.requestSubmit();
        } else {
          // if not enabled yet, just force a submit - this doesnt not trigger the "submit" event listener
          exitAlert = false;
          fullAppForm.submit();
        }
      }
    });
  });
}

/*  ==========================================================================
	APPLICATION - Error button in validation pop-up
	========================================================================== */

const fixErrorBtn = document.querySelector(".btn--fixerrors");

function closeValidationPopup() {
  validationPopup.classList.remove("popup--custom--show");

  if (validationPopupTrigger) {
    validationPopupTrigger.focus();
  }
}

if (validationPopup) {
  validationPopup.querySelector(".popup__close").addEventListener("click", function (e) {
    e.preventDefault();
    closeValidationPopup();
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && validationPopup.classList.contains("popup--custom--show")) {
      closeValidationPopup();
    }
  });
}

if (fixErrorBtn) {
  fixErrorBtn.addEventListener("click", function (e) {
    e.preventDefault();
    if (fullAppForm) {
      // always force submit on fix errors button so the user can move back through the form to find the errors
      // Action is updated in JS which checks validation to work out which page we need to move to
      exitAlert = false;
      fullAppForm.submit();
    }
  });
}
/*  ==========================================================================
	APPLICATION - Conditional Logic 
	========================================================================== */

function setupConditionals() {
  const conditionalLogic = document.querySelectorAll(".conditional-logic");
  if (conditionalLogic.length) {
    // Create autoresizing textarea inputs
    conditionalLogic.forEach(function (conditionalLogicItem) {
      // Check once on first load
      checkConditional(conditionalLogicItem);

      let conditionalFieldID = conditionalLogicItem.dataset.conditionalid;
      let conditionalFieldInputs = document.querySelectorAll(
        "#field-" + conditionalFieldID + " .appform__field__input"
      );

      // Check when field is changed
      conditionalFieldInputs.forEach(function (conditionalFieldInput) {
        conditionalFieldInput.addEventListener("change", function () {
          checkConditional(conditionalLogicItem);
        });
        conditionalFieldInput.addEventListener("input", function () {
          checkConditional(conditionalLogicItem);
        });
      });
    });
  }
}

function showConditionalField(conditionalModule, sectionID) {
  if (conditionalModule.classList.contains(formModuleHiddenClass)) {
    conditionalModule.classList.remove(formModuleHiddenClass);
    validateForm(conditionalModule, appSectionValidators[sectionID]);
  }
}

function hideConditionalField(conditionalModule, sectionID) {
  if (!conditionalModule.classList.contains(formModuleHiddenClass)) {
    conditionalModule.classList.add(formModuleHiddenClass);
    validateForm(conditionalModule, appSectionValidators[sectionID], true);
  }
}

function checkConditional(conditionalLogicItem) {
  // Get data of field this logic is conditional on
  let conditionalFieldID = conditionalLogicItem.dataset.conditionalid;
  let conditionalFieldInputs = document.querySelectorAll("#field-" + conditionalFieldID + " .appform__field__input");

  if (conditionalFieldInputs.length) {
    let conditionalFieldModule = conditionalFieldInputs[0].closest(".formmodule");
    let conditionalField = conditionalFieldInputs[0].closest(".appform__field");

    // Get data of field to show / hide
    let conditionalModule = conditionalLogicItem.closest(".formmodule");
    let fieldDisplay = conditionalLogicItem.dataset.fielddisplay;
    let conditionalValue = conditionalLogicItem.dataset.conditionalvalue;

    let sectionID = conditionalModule.closest(".appform__section").dataset.sectionid;

    if (conditionalFieldInputs.length && conditionalField) {
      let conditionalFieldValue = false;
      if (conditionalField.classList.contains("appform__field--radio-buttons")) {
        if (document.querySelector(".appform__field__input[name='" + conditionalFieldID + "']:checked")) {
          conditionalFieldValue = document.querySelector(
            ".appform__field__input[name='" + conditionalFieldID + "']:checked"
          ).value;
        }
      } else if (conditionalField.classList.contains("appform__field--checkbox-list")) {
        if (document.querySelector(".appform__field__input[value='" + conditionalValue + "']:checked")) {
          conditionalFieldValue = conditionalValue;
        } else {
          conditionalFieldValue = false;
        }
      } else if (conditionalField.classList.contains("appform__field--checkbox")) {
        if (document.querySelector(".appform__field__input[name='" + conditionalFieldID + "']:checked")) {
          conditionalFieldValue = "true";
        } else {
          conditionalFieldValue = "false";
        }
      } else {
        conditionalFieldValue = conditionalFieldInputs[0].value;
      }
      if (conditionalFieldModule.classList.contains(formModuleHiddenClass)) {
        // if the conditional field is hidden force this to be unsuccessful
        if (fieldDisplay === "show") {
          hideConditionalField(conditionalModule, sectionID);
        } else if (fieldDisplay === "hide") {
          showConditionalField(conditionalModule, sectionID);
        }
      } else if (conditionalFieldValue && conditionalFieldValue.toLowerCase() === conditionalValue.toLowerCase()) {
        // Successful conditional to show or hide depending on admin setting
        if (fieldDisplay === "show") {
          showConditionalField(conditionalModule, sectionID);
        } else if (fieldDisplay === "hide") {
          hideConditionalField(conditionalModule, sectionID);
        }
      } else {
        // Unsuccessful conditional
        if (fieldDisplay === "show") {
          hideConditionalField(conditionalModule, sectionID);
        } else if (fieldDisplay === "hide") {
          showConditionalField(conditionalModule, sectionID);
        }
      }
    }
  }
}

/*  ==========================================================================
	APPLICATION - Display Verification Popup
	========================================================================== */
function displayVerificationPopup(userEmail) {
  // add email to intro text
  let originalIntroContent = emailVerificationPopup.querySelector(".popup__content__text").textContent;
  let newIntroContent = originalIntroContent.replace("{email}", "<b>" + userEmail + "</b>");
  emailVerificationPopup.querySelector(".popup__content__text").innerHTML = newIntroContent;
  // show email verification popup / form
  emailVerificationPopupTrigger = document.activeElement;
  emailVerificationPopup.classList.add("popup--custom--show");
  emailVerificationPopup.querySelector(".popup__close").focus();
}

function closeVerificationPopup() {
  emailVerificationPopup.classList.remove("popup--custom--show");
  resetFormLoading(leadCaptureForm);

  if (emailVerificationPopupTrigger) {
    emailVerificationPopupTrigger.focus();
  }
}

if (emailVerificationPopup) {
  emailVerificationPopup.querySelector(".popup__close").addEventListener("click", function (e) {
    e.preventDefault();
    closeVerificationPopup();
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && emailVerificationPopup.classList.contains("popup--custom--show")) {
      closeVerificationPopup();
    }
  });
}

/*  ==========================================================================
	APPLICATION - Display Found Saved Popup
	========================================================================== */

function displayFoundSavedPopup(formData, userEmail, appName) {
  // add email to intro text
  let originalIntroContent = foundSavedPopup.querySelector(".popup__content__text").textContent;
  foundSavedPopupOriginalIntroContent = originalIntroContent;
  let newIntroContent = originalIntroContent.replace("{email}", "<b>" + userEmail + "</b>");
  newIntroContent = newIntroContent.replace("{application-name}", "<b>" + appName + "</b>");
  foundSavedPopup.querySelector(".popup__content__text").innerHTML = newIntroContent;
  // show popup
  foundSavedPopupTrigger = document.activeElement;
  foundSavedPopup.classList.add("popup--custom--show");
  foundSavedPopup.querySelector(".popup__close").focus();

  foundSavedPopup.querySelector(".btn--continue").addEventListener("click", function (e) {
    e.preventDefault();
    // user wants to continue so submit lead capture
    const popupButtons = foundSavedPopup.querySelector(".popup__btns");
    popupButtons.classList.add("popup__btns--loading");
    submitLeadCapture(formData);
  });
}

function closeFoundSavedPopup() {
  foundSavedPopup.classList.remove("popup--custom--show");
  foundSavedPopup.querySelector(".popup__content__text").innerHTML = foundSavedPopupOriginalIntroContent;
  resetFormLoading(leadCaptureForm);

  if (foundSavedPopupTrigger) {
    foundSavedPopupTrigger.focus();
  }
}

if (foundSavedPopup) {
  foundSavedPopup.querySelector(".popup__close").addEventListener("click", function (e) {
    e.preventDefault();
    closeFoundSavedPopup();
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && foundSavedPopup.classList.contains("popup--custom--show")) {
      closeFoundSavedPopup();
    }
  });
}

function resetFoundSavedPopup() {
  // hide popup /
  foundSavedPopup.classList.remove("popup--custom--show");
  // Reset buttons and loading status
  const popupButtons = foundSavedPopup.querySelector(".popup__btns");
  popupButtons.classList.remove("popup__btns--loading");
}

/*  ==========================================================================
	APPLICATION - Save for later
	========================================================================== */

function setupSaveForLater() {
  const sidebarSaveBtns = document.querySelectorAll(".sidebar__save__btn");

  if (sidebarSaveBtns.length && savePopup) {
    const userData = JSON.parse(getCookie("efapp_user_data"));
    const userEmail = userData.email;
    // Add email to intro content
    let originalIntroContent = savePopup.querySelector(".popup__content__text").textContent;
    let newIntroContent = originalIntroContent.replace("{email}", "<b>" + userEmail + "</b>");
    savePopup.querySelector(".popup__content__text").innerHTML = newIntroContent;

    // Setup sidebar button
    sidebarSaveBtns.forEach(function (sidebarSaveBtn) {
      sidebarSaveBtn.addEventListener("click", function (e) {
        e.preventDefault();
        // show email verification popup / form
        savePopup.classList.add("popup--custom--show");
      });
    });

    // Setup close click
    savePopup.querySelector(".popup__close").addEventListener("click", function (e) {
      e.preventDefault();
      // Hide popup
      savePopup.classList.remove("popup--custom--show");
    });

    // Setup cancel click
    savePopup.querySelector(".btn--cancel").addEventListener("click", function (e) {
      e.preventDefault();
      // Hide popup
      savePopup.classList.remove("popup--custom--show");
    });

    // Setup confirm click
    savePopup.querySelector(".btn--save").addEventListener("click", function (e) {
      e.preventDefault();

      let formData = getFieldData(fullAppForm);

      // get all other form data
      const appFormData = new FormData();

      appFormData.append("action", "applications__save_for_later");

      appFormData.append("email", userData.email);
      appFormData.append("firstname", userData.firstname);
      appFormData.append("lastname", userData.lastname);
      appFormData.append("app_id", userData.app_id);
      appFormData.append("application_postid", userData.application.post_id);

      appFormData.append("full_app_data", JSON.stringify(formData));
      $.ajax({
        type: "POST",
        url: php_variables.ajax_url, // AJAX handler
        data: appFormData,
        processData: false,
        contentType: false,
        beforeSend: function () {
          savePopup.querySelector(".popup__btns").classList.add("popup__btns--loading");
        },
        success: function (data) {
          let data_json = JSON.parse(data);
          let success = data_json.success;
          if (success) {
            // sucess form submitted
            let success_redirect = data_json.success_redirect;
            if (success_redirect) {
              // remove validation cookie - if there is one
              setCookie(validationCookieName, 0, 0);
              // redirect to thank you page
              exitAlert = false;
              window.location.href = success_redirect;
            } else {
              // Hide popup
              savePopup.querySelector(".popup__btns").classList.remove("popup__btns--loading");
              savePopup.classList.remove("popup--custom--show");
              showFormError(fullAppForm, "6717");
            }
          } else {
            // Hide popup
            savePopup.querySelector(".popup__btns").classList.remove("popup__btns--loading");
            savePopup.classList.remove("popup--custom--show");
            let error_code = data_json.error_code;
            showFormError(fullAppForm, error_code);
          }
        }
      });
    });
  }
}

setupSaveForLater();

/*  ==========================================================================
	APPLICATION - When closing child pages of the form, check if the user wants to leave and remind them data may be lost
	========================================================================== */

if (fullAppForm) {
  // This will only display / trigger after the user has interacted with the page
  window.addEventListener("beforeunload", function (e) {
    if (!exitAlert) {
      return false;
    }
    //following two lines will cause the browser to ask the user if they
    //want to leave. The text of this dialog is controlled by the browser.
    e.preventDefault(); //per the standard
    e.returnValue = ""; //required for Chrome
  });
}

/*  ==========================================================================
	APPLICATION - Retrieve saved application
	========================================================================== */

// Init form & setup validation
function initRetrieveSavedForm() {
  if (retrieveSavedForm) {
    const retrieveSavedValidator = new JustValidate(retrieveSavedForm, validatorSettings);
    validateForm(retrieveSavedForm, retrieveSavedValidator);
    retrieveSavedForm.addEventListener("submit", function (e) {
      if (!retrieveSavedValidator.isValid) {
        // if not valid yet, stop form submit
        e.preventDefault();
        scrollToFirstError();
      } else {
        // once valid, get form data & submit form
        retrieveSavedForm.submit();
      }
    });
  }
}

initRetrieveSavedForm();

// Verification Check
function submitSavedVerificationCheck() {
  // get all other form data
  let formData = getFieldData(retrieveSavedVerificationForm);
  const appFormData = new FormData();

  appFormData.append("action", "applications__verify_saved");

  appFormData.append("email", formData.filter(x => x.uniqueID === "email")[0].fieldValue);
  appFormData.append("app_id", formData.filter(x => x.uniqueID === "app_id")[0].fieldValue);
  appFormData.append("verification_code", formData.filter(x => x.uniqueID === "verification_code")[0].fieldValue);
  appFormData.append("recaptcha_response", document.getElementById("recaptchaResponse").value);

  $.ajax({
    type: "POST",
    url: php_variables.ajax_url, // AJAX handler
    data: appFormData,
    processData: false,
    contentType: false,
    beforeSend: function () {
      showFormLoading(retrieveSavedVerificationForm);
    },
    success: function (data) {
      let data_json = JSON.parse(data);
      let success = data_json.success;
      if (success) {
        // on success force a submit to post the data to the application form page
        retrieveSavedVerificationForm.submit();
      } else {
        let error_code = data_json.error_code;
        if (error_code === "6740") {
          showFormError(retrieveSavedVerificationForm, error_code, "Incorrect verification code, please try again.");
          // Empty the field to re-enter
          retrieveSavedVerificationForm.querySelector("#input-verification_code").value = "";
          // Re-focus on field
          retrieveSavedVerificationForm.querySelector("#input-verification_code").focus();
        } else {
          showFormError(retrieveSavedVerificationForm, error_code);
        }
        // Reset form loading
        resetFormLoading(retrieveSavedVerificationForm);
      }
    }
  });
}

// Init form & setup validation
function initRetrieveSavedVerificationForm() {
  if (retrieveSavedVerificationForm) {
    const retrieveSavedVerificationValidator = new JustValidate(retrieveSavedVerificationForm, validatorSettings);
    validateForm(retrieveSavedVerificationForm, retrieveSavedVerificationValidator);

    setupRecaptcha("retrievesaved");

    retrieveSavedVerificationForm.addEventListener("submit", function (e) {
      if (!retrieveSavedVerificationValidator.isValid) {
        // if not valid yet, stop form submit
        e.preventDefault();
        scrollToFirstError();
      } else {
        submitSavedVerificationCheck();
      }
    });
  }
}

initRetrieveSavedVerificationForm();
